import { connect } from 'react-redux';
import { selectMediaState, selectIsClient } from 'redux/modules/device';
import { filterSetFilterValue } from 'redux/saga/selectors';
import { withSagas } from 'decorators/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { SEARCH } from 'constants/filter-sets';
import { initializeUserLocationForSearch } from '../search.saga';
import { toggleMapView, selectMapView } from '../Search.reducer';
import { selectOpenPanel, selectKeywordSearchBoxText, selectLocationSearchBoxText, closeOpenPanel, setOpenPanel } from './SearchBox.reducer';
import { SearchBox } from './SearchBox';
import { FILTER_NAMES } from '../Search.constants';
import { PANEL_NAMES } from './SearchBox.constants';
import { watchSearchBoxSagas } from './SearchBox.saga';
export var mapStateToProps = function mapStateToProps(state) {
  var mediaQueryLg = selectMediaState(state).lg;
  var openPanel = selectOpenPanel(state);
  var isPanelOpenOnMobile = !!openPanel && !mediaQueryLg;
  var isKeywordOpen = openPanel === PANEL_NAMES.keyword;
  var isKeywordOpenOnMobile = isPanelOpenOnMobile && isKeywordOpen;
  var isLocationOpen = openPanel === PANEL_NAMES.location;
  var isLocationOpenOnMobile = isPanelOpenOnMobile && isLocationOpen;
  var isSearchPanelCollapsed = !isPanelOpenOnMobile && !mediaQueryLg;
  return {
    isHidden: !selectIsClient(state),
    // Hide the searchbox until the screen size is set from client to avoid visible repositioning while page loads
    isKeywordOpen: isKeywordOpen,
    isKeywordOpenOnMobile: isKeywordOpenOnMobile,
    isLocationOpen: isLocationOpen,
    isLocationOpenOnMobile: isLocationOpenOnMobile,
    isMapView: selectMapView(state),
    isPanelOpen: !!openPanel,
    isPanelOpenOnMobile: isPanelOpenOnMobile,
    isSearchPanelCollapsed: isSearchPanelCollapsed,
    keywordText: selectKeywordSearchBoxText(state),
    locationText: selectLocationSearchBoxText(state),
    selectedVertical: filterSetFilterValue(state, SEARCH, FILTER_NAMES.VERTICAL)
  };
};
var mapDispatchToProps = {
  onClickCollapsedSearchBar: setOpenPanel.bind(null, PANEL_NAMES.location),
  onPanelClose: closeOpenPanel,
  onToggleMapView: toggleMapView
};
export var SearchBoxContainer = decorateWith(connect(mapStateToProps, mapDispatchToProps), withSagas({
  load: initializeUserLocationForSearch,
  watch: watchSearchBoxSagas
}), withName('SearchBoxContainer'))(SearchBox);